/* Mattress Overstock landing pages (Meta ad destinations), 2026-09-26.
 * Vanilla JS, no libraries. Every module degrades to the server-rendered page.
 * prefers-reduced-motion: no reveals, no springs; values jump to their end state. */
(function () {
  'use strict';
  if (window.MOLP) return;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var TZ = 'America/New_York';
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function $$(sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Open-now status (Eastern time, published hours, holiday closures) ---------- */
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25),
      g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
      l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    return [Math.floor((h + l - 7 * m + 114) / 31), ((h + l - 7 * m + 114) % 31) + 1];
  }
  function holiday(y, mo, d) {
    if (mo === 12 && d === 25) return 'Christmas Day';
    var e = easter(y); if (mo === e[0] && d === e[1]) return 'Easter';
    if (mo === 11) { var first = new Date(Date.UTC(y, 10, 1)).getUTCDay(); var th = 1 + ((4 - first + 7) % 7) + 21; if (d === th) return 'Thanksgiving'; }
    return null;
  }
  function nowET() {
    var p = {}; new Intl.DateTimeFormat('en-US', { timeZone: TZ, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hourCycle: 'h23', weekday: 'short' })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { y: +p.year, mo: +p.month, d: +p.day, h: +p.hour % 24, mi: +p.minute, wd: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(p.weekday) };
  }
  function fmt(h) { var s = h >= 12 ? 'pm' : 'am', hh = h % 12 || 12; return hh + ' ' + s; }
  function addDays(t, n) { var dt = new Date(Date.UTC(t.y, t.mo - 1, t.d + n)); return { y: dt.getUTCFullYear(), mo: dt.getUTCMonth() + 1, d: dt.getUTCDate(), wd: dt.getUTCDay() }; }
  function parseHours(s) { // "12-18,10-19,..." Sun..Sat
    return (s || '12-18,10-19,10-19,10-19,10-19,10-19,10-19').split(',').map(function (x) { var a = x.split('-'); return [+a[0], +a[1]]; });
  }
  function status(hoursAttr) {
    var H = parseHours(hoursAttr), t = nowET(), mins = t.h * 60 + t.mi, hol = holiday(t.y, t.mo, t.d), today = H[t.wd];
    if (!hol && mins >= today[0] * 60 && mins < today[1] * 60) return { cls: 'is-open', text: 'Open now · until ' + fmt(today[1]) };
    if (!hol && mins < today[0] * 60) return { cls: 'is-soon', text: 'Opens today at ' + fmt(today[0]) };
    for (var n = 1; n < 8; n++) {
      var dd = addDays(t, n); if (holiday(dd.y, dd.mo, dd.d)) continue;
      var when = n === 1 ? 'tomorrow' : DAYS[dd.wd];
      return { cls: 'is-closed', text: (hol ? 'Closed today for ' + hol : 'Closed now') + ' · opens ' + when + ' at ' + fmt(H[dd.wd][0]) };
    }
    return null;
  }
  function paintStatus(root) {
    $$('[data-mo-status]', root).forEach(function (el) {
      try {
        var s = status(el.getAttribute('data-hours')); if (!s) return;
        var t = el.querySelector('[data-mo-status-text]') || el;
        t.textContent = s.text;
        el.classList.remove('is-open', 'is-soon', 'is-closed'); el.classList.add(s.cls);
      } catch (e) { /* keep server text */ }
    });
  }

  /* ---------- Reveal on approach (below-fold only) ---------- */
  var io = null;
  function reveals(root) {
    if (reduced || !('IntersectionObserver' in window)) return;
    if (!io) io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
    var vh = window.innerHeight;
    $$('[data-reveal]', root).forEach(function (el, i) {
      if (el.__moRv) return; el.__moRv = 1;
      if (el.getBoundingClientRect().top < vh) return; // on screen already: never hide
      el.classList.add('mo-lp-pre');
      el.style.transitionDelay = (Math.min(+(el.getAttribute('data-reveal') || 0), 4) * 70) + 'ms';
      io.observe(el);
    });
    setTimeout(function () { $$('.mo-lp-pre:not(.is-in)', root).forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in'); }); }, 6000);
  }

  /* ---------- Visit steps: scroll-linked progress line ---------- */
  function steps(root) {
    $$('[data-mo-steps]', root).forEach(function (list) {
      if (list.__mo) return; list.__mo = 1;
      var items = $$('.mo-lp-step', list), fill = list.querySelector('.mo-lp-steps__fill'), tick = false;
      function run() {
        tick = false;
        var vh = window.innerHeight, r = list.getBoundingClientRect(), line = vh * 0.62;
        var p = Math.max(0, Math.min(1, (line - r.top) / Math.max(1, r.height - 40)));
        if (fill) fill.style.setProperty('--p', reduced ? 1 : p.toFixed(3));
        items.forEach(function (it) { it.classList.toggle('is-on', reduced || it.getBoundingClientRect().top < line); });
      }
      window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(run); } }, { passive: true });
      window.addEventListener('resize', run);
      run();
    });
  }

  /* ---------- Before-you-come checklist ---------- */
  function checklist(root) {
    $$('[data-mo-check]', root).forEach(function (box) {
      if (box.__mo) return; box.__mo = 1;
      var key = 'mo-lp-check:' + (box.getAttribute('data-mo-check') || location.pathname), saved = {};
      try { saved = JSON.parse(localStorage.getItem(key) || '{}'); } catch (e) { saved = {}; }
      var btns = $$('button[aria-pressed]', box), count = box.querySelector('[data-mo-check-count]'), bar = box.querySelector('.mo-lp-check__bar i');
      function paint() {
        var n = btns.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; }).length;
        if (count) count.textContent = n === btns.length ? 'Ready to lie down.' : n + ' of ' + btns.length + ' ready';
        if (bar) bar.style.setProperty('--w', (n / btns.length * 100) + '%');
      }
      btns.forEach(function (b, i) {
        if (saved[i]) b.setAttribute('aria-pressed', 'true');
        b.addEventListener('click', function () {
          var on = b.getAttribute('aria-pressed') !== 'true';
          b.setAttribute('aria-pressed', on ? 'true' : 'false'); saved[i] = on;
          try { localStorage.setItem(key, JSON.stringify(saved)); } catch (e) {}
          paint();
        });
      });
      paint();
    });
  }

  /* ---------- Feel switcher (tabs) ---------- */
  function family(root) {
    $$('[data-mo-family]', root).forEach(function (sec) {
      if (sec.__mo) return; sec.__mo = 1;
      var tabs = $$('[role="tab"]', sec), panels = $$('[role="tabpanel"]', sec), viz = sec.querySelector('[data-mo-viz]');
      var fVal = sec.querySelector('[data-viz-f]'), hVal = sec.querySelector('[data-viz-h]'), shown = false;
      function select(i, focus) {
        tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); t.tabIndex = j === i ? 0 : -1; });
        panels.forEach(function (p, j) { p.hidden = j !== i; if (j === i && shown) { p.classList.remove('is-swap'); void p.offsetWidth; p.classList.add('is-swap'); } });
        var t = tabs[i]; if (!t) return;
        var f = t.getAttribute('data-f'), h = t.getAttribute('data-h');
        if (viz) {
          if (f) { viz.style.setProperty('--f', f); if (fVal) fVal.textContent = f + ' / 10'; }
          if (h) { viz.style.setProperty('--h', h); if (hVal) hVal.textContent = h + ' in'; }
          viz.hidden = !(f || h);
        }
        if (focus) t.focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(i); });
        t.addEventListener('keydown', function (e) {
          var k = e.key, n = tabs.length;
          if (k === 'ArrowRight' || k === 'ArrowDown') { e.preventDefault(); select((i + 1) % n, true); }
          if (k === 'ArrowLeft' || k === 'ArrowUp') { e.preventDefault(); select((i - 1 + n) % n, true); }
          if (k === 'Home') { e.preventDefault(); select(0, true); }
          if (k === 'End') { e.preventDefault(); select(n - 1, true); }
        });
      });
      var start = Math.max(0, tabs.findIndex(function (t) { return t.getAttribute('aria-selected') === 'true'; }));
      // Knob and bed start soft/low, then spring to the selected bed once in view.
      if (viz && !reduced && 'IntersectionObserver' in window) {
        viz.style.setProperty('--f', 1); viz.style.setProperty('--h', 9);
        var o = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { o.disconnect(); setTimeout(function () { shown = true; select(start); }, 180); } }, { threshold: 0.35 });
        o.observe(viz);
        select(start); viz.style.setProperty('--f', 1); viz.style.setProperty('--h', 9);
      } else { shown = true; select(start); }
    });
  }

  /* ---------- Store list: distance sort (tap), FLIP reorder, map sync ---------- */
  function miles(a, b, c, d) { var R = 3958.8, p = Math.PI / 180, h = Math.sin((c - a) * p / 2), w = Math.sin((d - b) * p / 2); return 2 * R * Math.asin(Math.sqrt(h * h + Math.cos(a * p) * Math.cos(c * p) * w * w)); }
  function pinFor(root, name) {
    return $$('.mo-pin', root).filter(function (a) { return (a.textContent || '').trim().toLowerCase() === String(name).toLowerCase(); })[0];
  }
  function stores(root) {
    $$('[data-mo-stores]', root).forEach(function (sec) {
      if (sec.__mo) return; sec.__mo = 1;
      var list = sec.querySelector('.mo-lp-stores'), btn = sec.querySelector('[data-mo-geo]');
      if (!list) return;
      function activate(name) {
        $$('.mo-pin', sec).forEach(function (a) { a.classList.toggle('is-active', !!name && (a.textContent || '').trim().toLowerCase() === name.toLowerCase()); });
      }
      $$('.mo-lp-store', list).forEach(function (card) {
        var n = card.getAttribute('data-name');
        card.addEventListener('mouseenter', function () { activate(n); });
        card.addEventListener('focusin', function () { activate(n); });
      });
      function sort(lat, lng) {
        var cards = $$('.mo-lp-store', list), first = new Map();
        cards.forEach(function (c) { first.set(c, c.getBoundingClientRect().top); });
        cards.forEach(function (c) {
          var d = miles(lat, lng, +c.getAttribute('data-lat'), +c.getAttribute('data-lng')); c.__d = d;
          var el = c.querySelector('.mo-lp-store__dist'); if (el) { el.textContent = 'About ' + Math.max(1, Math.round(d)) + ' mi away'; el.hidden = false; }
          c.classList.remove('is-near');
        });
        cards.sort(function (a, b) { return a.__d - b.__d; }).forEach(function (c) { list.appendChild(c); });
        cards[0].classList.add('is-near');
        activate(cards[0].getAttribute('data-name'));
        if (!reduced) cards.forEach(function (c) {
          var dy = first.get(c) - c.getBoundingClientRect().top; if (!dy) return;
          c.style.transition = 'none'; c.style.transform = 'translateY(' + dy + 'px)';
          requestAnimationFrame(function () { requestAnimationFrame(function () { c.style.transition = ''; c.style.transform = ''; }); });
        });
        if (btn) { btn.classList.add('is-done'); var l = btn.querySelector('[data-label]'); if (l) l.textContent = 'Sorted by distance'; btn.removeAttribute('aria-busy'); }
      }
      function locate() {
        if (!navigator.geolocation) return;
        if (btn) btn.setAttribute('aria-busy', 'true');
        navigator.geolocation.getCurrentPosition(function (p) { sort(p.coords.latitude, p.coords.longitude); },
          function () { if (btn) { btn.removeAttribute('aria-busy'); var l = btn.querySelector('[data-label]'); if (l) l.textContent = 'Location is off. Pick a town below.'; } },
          { maximumAge: 600000, timeout: 9000 });
      }
      if (btn) btn.addEventListener('click', locate);
      // Only sort silently when the visitor already allowed location for this site.
      if (navigator.permissions && navigator.permissions.query) {
        navigator.permissions.query({ name: 'geolocation' }).then(function (s) { if (s.state === 'granted') locate(); }).catch(function () {});
      }
    });
  }

  /* ---------- Map: mark the current store's pin once mo-anim.js builds it ---------- */
  function mapHere(root) {
    $$('[data-mo-here]', root).forEach(function (map) {
      if (map.__moHere) return; map.__moHere = 1;
      var name = map.getAttribute('data-mo-here'), tries = 0;
      (function find() {
        var pin = pinFor(map, name);
        if (!pin) { if (tries++ < 40) setTimeout(find, 250); return; }
        pin.classList.add('is-here');
        var ring = document.createElement('span'); ring.className = 'mo-lp-pulse'; ring.setAttribute('aria-hidden', 'true');
        setTimeout(function () { pin.appendChild(ring); }, reduced ? 0 : 3600);
      })();
    });
  }

  /* ---------- Phone dock: after the hero buttons leave the screen, before the closing band ---------- */
  function dock() {
    var heroCtas = document.querySelector('[data-mo-hero-ctas]');
    if (heroCtas && !heroCtas.__moTop && 'IntersectionObserver' in window) {
      heroCtas.__moTop = 1;
      // While the hero buttons are on screen, keep the chat quiz nudge from covering them (phones only, via CSS).
      document.documentElement.classList.add('mo-lp-at-top');
      new IntersectionObserver(function (es) { document.documentElement.classList.toggle('mo-lp-at-top', es[0].isIntersecting); }).observe(heroCtas);
    }
    var d = document.querySelector('.mo-lp-dock');
    if (!d || d.__mo || !('IntersectionObserver' in window)) return; d.__mo = 1;
    var close = document.querySelector('[data-mo-close]');
    var past = false, atClose = false;
    function paint() { d.classList.toggle('is-on', past && !atClose); }
    if (heroCtas) new IntersectionObserver(function (es) { var e = es[0]; past = !e.isIntersecting && e.boundingClientRect.top < 0; paint(); }).observe(heroCtas);
    if (close) new IntersectionObserver(function (es) { atClose = es[0].isIntersecting; paint(); }, { threshold: 0.15 }).observe(close);
  }

  function boot(root) {
    root = root || document;
    paintStatus(root); reveals(root); steps(root); checklist(root); family(root); stores(root); mapHere(root); dock();
  }
  window.MOLP = { boot: boot, status: status };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  setInterval(function () { paintStatus(document); }, 60000);
})();
